module.exports = __webpack_public_path__ + "media/stylesheets/fonts/fontawesome/fa-regular-400-3ac49cb33f43a6471f21ab3df40d1b1e.eot";